export default __webpack_public_path__ + "static/media/cardImage.2a78c194.svg";